export enum FileTypeEnum {
  Unknown = 'Unknown',
  Word = 'Word',
  Excel = 'Excel',
  Powerpoint = 'Powerpoint',
  Wopitest = 'Wopitest',
  Text = 'Text',
  Image = 'Image',
  Audio = 'Audio',
  Video = 'Video',
  Pdf = 'Pdf',
  Code = 'Code',
  Eml = 'Eml',
  Ics = 'Ics',
  Vcf = 'Vcf',
  Msg = 'Msg',
  Secret = 'Secret',
  Note = 'Note',
}
